import React, { useState, useEffect } from 'react'

export function Footer(props) {

    const [BrandingName, setBrandingName] = useState();
    const [SupportEmail, setSupportEmail] = useState();
    const [Facebook, setFacebook] = useState();
    const [LinkedIn, setLinkedIn] = useState();

    useEffect(() => {



    }, []);

    return (
        <>
            <div className="">
                <footer className="mb-0 py-4 border-top border-secondary border-opacity-25" style={{ backgroundColor: '#080B11' }}>
                    <div className="container">
                        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
                            <div className="d-flex align-items-center gap-2">
                                <div className="rounded-2 d-flex align-items-center justify-center p-1" style={{ backgroundColor: '#00F0FF', width: '28px', height: '28px' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.5">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                    </svg>
                                </div>
                                <span className="fw-bold text-white mb-0">SERITY</span>
                            </div>

                            <p className="text-secondary small mb-0 text-center">
                                © {new Date().getFullYear()} Serity. All rights reserved.
                                <div className="mb-3">
                                    Be our partner: <a href="bookings@westoztransport.com">{SupportEmail ? SupportEmail : "bookings@westoztransport.com"}</a>
                                </div>
                            </p>

                            <div className="d-flex gap-3 text-secondary small">
                                <ul className="nav justify-content-end list-unstyled d-flex">
                                    <li className="ms-3"><a className="text-muted" href={Facebook ? Facebook : "https://www.facebook.com/westoztransport/"} target="_blank" rel="noreferrer"><i className="fa fa-facebook"></i></a></li>
                                    <li className="ms-3"><a className="text-muted" href={LinkedIn ? LinkedIn : "https://www.linkedin.com/company/westoz-transport"}><i className="fa fa-linkedin"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>

        </>


    );
}